var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100vw"},attrs:{"id":"channelmanagement"}},[_c('div',{attrs:{"id":"a0534b03"}},[_vm._v(" 开发中列表 ")]),_c('div',{attrs:{"id":"a77fbc1e"}},[_vm._v(" 页面设计中～ ")])])
}]

export { render, staticRenderFns }